<script>
  import { env } from '$env/dynamic/public';

  /** @type {import('$lib/types/getAllLaunch.js').Launch} */
  export let launch;
  /** @type {string?} */
  let badge;
  /** @type {string} */
  let badgeType;
  /** @type {string} */
  let imageUrl;
  /** @type {string} */
  let imageAlt;
  let loadImage = true;

  $: launch, loadDetails();

  function loadDetails() {
    loadImage = true;
    badge = launch.type == 1 ? 'Rideshare' : launch.type == 2 ? 'Piggyback' : null;
    badgeType = launch.type == 2 ? 'secondary' : 'primary';
    imageUrl = `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}vehicles/${launch.vehicle.id}/image`;
    imageAlt = `${launch.operator.name}'s ${launch.vehicle.name} vehicle`;
  }
</script>

{#if badge}
  <span class="position-absolute m-3 top-0 end-0 badge rounded-pill bg-{badgeType}">
    {badge}
  </span>
{/if}

<div class="p-3 d-flex justify-content-center card-image">
  {#if loadImage}
    <img src={imageUrl} alt={imageAlt} on:error={() => (loadImage = false)} />
  {:else}
    <div class="img-placeholder"></div>
  {/if}
</div>

<style>
  .card-image {
    background-color: var(--grey-15);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  img {
    height: 180px;
    aspect-ratio: 1/3;
    object-fit: contain;
  }

  .img-placeholder {
    height: 180px;
  }
</style>
